/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";
// Redux Imports
import { useDispatch, useSelector } from "react-redux";

// components imports
import Validation from "../../../../../utils/validation";
import AccountName from "../../../../../components/_utils/AccountCreationComponents/AccountName";
import ContactDetails from "../../../../../components/_utils/AccountCreationComponents/ContactDetails";

import { getAllCategories } from "../../../../../redux/features/sharedResources/sharedResources";
import CommonLayout from "../../../../../components/_utils/CommonLayout";
import LinkEntityCard from "../../../../../components/_utils/LinkEntityCard";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";

const CreateContact = (props) => {
  const dispatch = useDispatch();
  const [contactNumberValidation, setContactNumberValidation] = useState(false);
  const [emailValidation, setEmailValidation] = useState(false);
  const [customErrors, setCustomErrors] = useState({});
  const categories = props.categories;

  const handleRadioBtn = (event) => {
    handleAccountNameSelection(event.target.value);
  };

  const { panVerificationData, verifyBankAccountData } = useSelector(
    (state) => state.sharedResources,
  );
  const bankAccountName =
    verifyBankAccountData?.status === true
      ? verifyBankAccountData?.verification_details?.[0]?.full_name || ""
      : "";

  const allCategoryIds = useMemo(() => {
    return categories.map((category) => category.id);
  }, []);
  const isAllSelected = useMemo(() => {
    return props?.selectedCatFields.length === allCategoryIds.length;
  }, [props?.selectedCatFields, allCategoryIds]);

  const handleUpdateLegalName = () => {
    const beneficiaryData = panVerificationData?.pan_details?.full_name;
    props?.setPayload((prevPayload) => ({
      ...prevPayload,
      account_name: beneficiaryData,
    }));
    props?.setAccountNameValidation(true);
  };

  const handleUpdateUsername = () => {
    props?.setAccountNameValidation(true);
    props.setPayload((prev) => ({
      ...prev,
      account_name: props.payload.userName,
    }));
  };

  const handleUpdateBankAccountName = () => {
    props?.setAccountNameValidation(Boolean(bankAccountName.trim()));
    props.setPayload((prev) => ({
      ...prev,
      account_name: bankAccountName,
    }));
  };

  const handleAccountNameSelection = (value) => {
    props?.setSelectedValue(value);

    if (value === "legalname") {
      handleUpdateLegalName();
    } else if (value === "username") {
      handleUpdateUsername();
    } else if (value === "bankaccountname") {
      handleUpdateBankAccountName();
    }
  };

  const handleCategorySelect = (selectedCategories) => {
    let selectedCategoryNames = [];

    if (selectedCategories.length > 0) {
      selectedCategoryNames = selectedCategories
        .map((categoryId) => {
          const category = categories.find(
            (category) => category.id === categoryId,
          );
          return category ? category.name : null;
        })
        .filter((name) => name !== null);
    } else {
      selectedCategoryNames = categories.map((category) => category.name);
    }

    props.onSelectFieldsChange(selectedCategoryNames);
  };

  const emailRegex = Validation.emailRegex;

  const modifyValue = (type, value) => {
    if (type === "gstin") {
      return value?.toUpperCase();
    }
    return value.trim();
  };

  const allowedValue = (name, value) => {
    if (name === "contact_no") return Validation.allowedContactNum(value);
    if (name === "email_id") return Validation.allowedEmail(value);
    return true;
  };

  const validateAndRecordError = (name, value) => {
    let errors = { ...customErrors };
    if (name === "email_id")
      errors = Validation.validateEmail(name, value, errors);
    if (name === "contact_no")
      errors = Validation.validateContactNum(name, value, errors);

    setCustomErrors(errors);
  };

  const handleChange = (e) => {
    let { name, value } = e.target;
    if (name !== "account_name") {
      value = modifyValue(name, value?.replace(/\s/g, ""));
    } else {
      value = value.replace(/\s+/g, " ");
    }

    if (props.payload) {
      if (allowedValue(name, value)) {
        validateAndRecordError(name, value);
        const newObj = { ...props.payload, [name]: value };
        props?.setPayload(newObj);
      }
      if (
        props?.payload?.contact_no &&
        (props?.payload?.contact_no?.length === 0 ||
          props?.payload?.contact_no?.length < 10)
      ) {
        setContactNumberValidation(false);
      }
      if (props?.payload?.email_id && props?.payload?.email_id?.length === 0) {
        setEmailValidation(false);
      }
      if (name === "account_name") {
        if (value.trim().length > GlobalConfiguration.lengthCheckTwo) {
          if (value === panVerificationData?.pan_details?.full_name) {
            props?.setSelectedValue("legalname");
          } else if (value === props.payload.userName) {
            props?.setSelectedValue("username");
          } else if (value === bankAccountName) {
            props?.setSelectedValue("bankaccountname");
          } else {
            props?.setSelectedValue("customname");
          }
          props?.setAccountNameValidation(true);
        } else {
          props?.setAccountNameValidation(false);
        }
      }
    }
  };

  useMemo(() => {
    if (customErrors["contact_no"]) {
      setContactNumberValidation(false);
    }
    if (
      !customErrors["contact_no"] &&
      props.payload.contact_no?.length === 10
    ) {
      setContactNumberValidation(true);
    }
    if (customErrors["email_id"]) {
      setEmailValidation(false);
    }
    if (
      !customErrors["email_id"] &&
      props.payload.email_id?.length > 0 &&
      emailRegex.test(props.payload.email_id)
    ) {
      setEmailValidation(true);
    }
  }, [contactNumberValidation, emailValidation, customErrors, props.payload]);

  useEffect(() => {
    if (
      emailValidation &&
      contactNumberValidation &&
      props?.accountNameValidation
    ) {
      props.BenEnableNextButton(false);
      props.parentCreateBen({
        email: emailValidation,
        contact: contactNumberValidation,
        accountname: props?.accountNameValidation,
      });
    } else if (props?.activeStep === 2) {
      props.parentCreateBen({
        email: emailValidation,
        contact: contactNumberValidation,
        accountname: props?.accountNameValidation,
      });
      props.BenEnableNextButton(true);
    }
    handleCategorySelect(props?.selectedCatFields);
  }, [
    props?.selectedCatFields,
    // categories,
    isAllSelected,
    emailValidation,
    contactNumberValidation,
    props?.accountNameValidation,
    props?.activeStep,
  ]);
  useEffect(() => {
    dispatch(getAllCategories());
  }, []);

  const handleDivBtn = (value) => {
    handleAccountNameSelection(value);
  };

  return (
    <>
      <div className="px-padding-md lg:px-padding-base py-padding-md Qsmd:py-padding-base">
        <CommonLayout>
          <AccountName
            handleChange={handleChange}
            accountNameValidation={props?.accountNameValidation}
            accountName={props.payload.account_name}
            selectedValue={props?.selectedValue}
            handleDivBtn={handleDivBtn}
            handleRadioBtn={handleRadioBtn}
            selectedRadioValue={props?.selectedValue}
            legalName={props?.payload?.legalName}
            type={"user"}
            userName={props.payload.userName}
            bankAccountName={bankAccountName}
            placeHolder={"Account name"}
          />

          <div
            className={`flex flex-col relative w-width-full lg:max-w-[var(--create-box-width)] gap-gap-md `}
          >
            <LinkEntityCard
              payload={props?.payload}
              setPayload={props?.setPayload}
              selectedValue={props?.selectedValue}
              headerTitle="User view all"
              redirectPath="/settings/user_view_all"
              title="User"
              description="Linked user will be able to create reimbursement requests."
              buttonText="Link user"
              nameKey="userName"
              idKey="userId"
              nameLabel="Username"
              idLabel="User ID"
              isOptional={true}
            />
            <ContactDetails
              handleChange={handleChange}
              contactNumberValidation={contactNumberValidation}
              emailValidation={emailValidation}
              contactNumber={props?.payload?.contact_no}
              emailId={props?.payload?.email_id}
              selectedValue={props?.selectedValue}
            />
          </div>
        </CommonLayout>
      </div>
    </>
  );
};

export default CreateContact;
